var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWealthCheckDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9L2 1H14.5L8.5 9Z",
    fill: "#E06336",
    stroke: "#E06336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWealthCheckDrop);
export default __webpack_public_path__ + "static/media/Wealth_Check_Drop.aa9ca767442a7b5d2306593364e95d74.svg";
export { ForwardRef as ReactComponent };